import React from 'react';

// Full Arch ROI — Premium deep blue dental arch logo
export default function Logo({ size = 36, showText = true, light = true }) {
  const textColor = light ? '#F8FAFC' : '#0F172A';
  const subColor = light ? 'rgba(148,163,184,0.8)' : '#64748B';

  return (
    <div className="flex items-center gap-2.5">
      {/* SVG Mark */}
      <svg width={size} height={size} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Background */}
        <rect width="44" height="44" rx="10" fill="#1D4ED8"/>
        {/* Subtle inner highlight */}
        <rect width="44" height="44" rx="10" fill="url(#logo-shine)" opacity="0.4"/>
        {/* Arch curve */}
        <path
          d="M9 30 Q9 14 22 12 Q35 14 35 30"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        {/* Implant posts — 5 posts */}
        <line x1="12" y1="28" x2="12" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <line x1="17" y1="24" x2="17" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <line x1="22" y1="22" x2="22" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <line x1="27" y1="24" x2="27" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <line x1="32" y1="28" x2="32" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        {/* Baseline */}
        <line x1="9" y1="34" x2="35" y2="34" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
        {/* Small abutments / dots on posts */}
        <circle cx="12" cy="27.5" r="1.5" fill="white"/>
        <circle cx="17" cy="23.5" r="1.5" fill="white"/>
        <circle cx="22" cy="21.5" r="1.5" fill="white"/>
        <circle cx="27" cy="23.5" r="1.5" fill="white"/>
        <circle cx="32" cy="27.5" r="1.5" fill="white"/>
        {/* Gradient def */}
        <defs>
          <linearGradient id="logo-shine" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="white" stopOpacity="0.15"/>
            <stop offset="100%" stopColor="white" stopOpacity="0"/>
          </linearGradient>
        </defs>
      </svg>

      {showText && (
        <div className="leading-tight">
          <p className="font-heading font-bold tracking-tight" style={{ color: textColor, fontSize: 15, lineHeight: '1.2' }}>
            Full Arch ROI
          </p>
          <p className="font-body" style={{ color: subColor, fontSize: 10.5, letterSpacing: '0.02em' }}>
            Performance Dashboard
          </p>
        </div>
      )}
    </div>
  );
}
